import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import CategoryHero from './CategoryHero';
import { useManagedCollection, slugify } from '../admin/useManagedCollection';
import { AdminItem, AdminAddBar } from '../admin/AdminControls';
import type { FieldDef } from '../admin/AdminFieldModal';
import NewsTicker from './NewsTicker';
import SocialLinks, { SOCIAL_FIELDS } from './SocialLinks';
import { ShoppingCard } from './Shopping';

const PHOTO_VIDEO_FIELDS: FieldDef[] = [
  { key: 'name', label: 'Name', required: true },
  { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Describe this photographer/videographer…' },
  { key: 'instagramUrl', label: 'Instagram URL', type: 'url', placeholder: 'https://…' },
  { key: 'image', label: 'Image URL', type: 'image', placeholder: 'https://…' },
  ...SOCIAL_FIELDS,
];

export const PHOTO_VIDEO_ENTRIES = [
  {
    id: 'dtc-photography',
    name: 'DTC Photography (Down To Capture)',
    instagramUrl: 'https://www.instagram.com/downtocapture/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784285351714-fkd7bh.png',
  },
  {
    id: 'creatives-photography',
    name: 'Creatives Photography',
    instagramUrl: 'https://www.instagram.com/creatives._photography/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784441818224-a5l0bi.png',
  },
  {
    id: 'ansion-studios',
    name: 'Ansion Studios',
    instagramUrl: 'https://www.instagram.com/framesbyharshini/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784442092839-6vw3ut.png',
  },
  {
    id: 'videsi-lens',
    name: 'Videsi Lens',
    instagramUrl: 'https://www.instagram.com/videsi_lens/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784442140015-57d50r.png',
  },
  {
    id: 'eternal-focus',
    name: 'Eternal Focus',
    instagramUrl: 'https://www.instagram.com/eternalfocus_photography/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784442210684-48x7yj.png',
  },
  {
    id: 'dallas-photographer-sayyam-farooq',
    name: 'Dallas Photographer | Sayyam Farooq',
    instagramUrl: 'https://www.instagram.com/sayyam.farooq',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784444129238-5x5b44.png',
  },
  {
    id: 'nth-clicks-photography',
    name: 'N\u2019th clicks Photography',
    instagramUrl: 'https://www.instagram.com/nthclicks/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784658860634-k97slk.png',
  },
  {
    id: 'click-bright-7',
    name: 'Click Bright 7',
    instagramUrl: 'https://www.instagram.com/clickbright7/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784659192041-73rd0a.png',
  },
  {
    id: 'tales-by-naqsh',
    name: 'Tales By Naqsh',
    instagramUrl: 'https://www.instagram.com/talesbynaqsh/',
    image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784659848849-8yzo6r.png',
  },
  {
    id: 'cheesenfreezeshots-by-sundar',
    name: 'CheeSeNfreeZesHoTs bY sUnDar',
    instagramUrl: 'https://www.instagram.com/cheesenfreezeshots/',
    image: 'https://storage.googleapis.com/happyspace-generated-images/form-uploads/2026-07-22/058c0c9f4534.jpeg',
  },
  {
    id: 'what-a-story',
    name: 'What A Story',
    image: 'https://storage.googleapis.com/happyspace-generated-images/form-uploads/2026-10-22/a135836c296d.jpeg',
    website: 'https://whataweddingstory.com/wedding-photographer-and-videographer-in-dallas/',
    phone: '510-529-8961',
    address: 'North St. Paul Street, Dallas, TX 75201, USA',
  },
];

export const FEATURED_TASTEBUDS_ENTRY = {
  id: 'creativex',
  name: 'CreativeX - "Where Creativity Meets Strategy"',
  instagramUrl: 'https://www.instagram.com/creativexspace_/',
  instagram: 'https://www.instagram.com/creativexspace_/',
  shopUrl: 'https://www.instagram.com/creativexspace_/',
  linkLabel: 'Instagram',
  image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784440805927-64nd56.png',
};

export const FEATURED_TASTEBUDS_ENTRY_FLASHBRUSH = {
  id: 'flash-brush-weddings-featured',
  name: 'Flash Brush Weddingsandevents',
  instagramUrl: 'https://www.instagram.com/p/DQm-JLlEpPR/?img_index=2&igsh=YjAxamJxZ255bDkx',
  instagram: 'https://www.instagram.com/p/DQm-JLlEpPR/?img_index=2&igsh=YjAxamJxZ255bDkx',
  shopUrl: 'https://www.instagram.com/p/DQm-JLlEpPR/?img_index=2&igsh=YjAxamJxZ255bDkx',
  linkLabel: 'Instagram',
  image: 'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784441880602-zm2g7f.png',
};

// Every photo/video listing's public detail-page URL is derived from its stable
// id, or (for admin-added cards with no preset id) its name — same pattern as
// shoppingSlug in Shopping.tsx. Used by both the card link and
// PhotoVideoDetailPage's lookup.
export function photoVideoSlug(e: { id?: string; name?: string }) {
  return slugify((e as any).id || (e as any).name || '');
}

export function PhotoVideoCard({ entry, index, linkDetail }: { entry: typeof PHOTO_VIDEO_ENTRIES[0]; index: number; linkDetail?: boolean }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.4, delay: index * 0.08 }}
      className="bg-white rounded-md border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden flex flex-col"
      style={{ fontFamily: "'Poppins', sans-serif" }}
    >
      {linkDetail ? (
        <Link
          to={`/photo-video/${photoVideoSlug(entry as any)}`}
          className="flex-1 flex flex-col no-underline"
          aria-label={`View ${entry.name} details`}
        >
          <div className="w-full aspect-[4/3] relative overflow-hidden">
            <img
              src={entry.image}
              alt={entry.name}
              className="w-full h-full object-cover"
              loading="lazy"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=600&h=400&fit=crop';
              }}
            />
          </div>
          <div className="p-1.5 pb-0.5 flex-1">
            <h3 className="text-[10px] font-bold text-gray-900 leading-tight truncate hover:text-[#f97316] hover:underline transition-colors">
              {entry.name}
            </h3>
            {(entry as any).description && (
              <p className="text-[9px] text-gray-500 leading-snug mt-0.5 line-clamp-2">{(entry as any).description}</p>
            )}
          </div>
        </Link>
      ) : (
        <>
          <div className="w-full aspect-[4/3] relative overflow-hidden">
            <img
              src={entry.image}
              alt={entry.name}
              className="w-full h-full object-cover"
              loading="lazy"
              onError={(e) => {
                (e.target as HTMLImageElement).src = 'https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=600&h=400&fit=crop';
              }}
            />
          </div>
          <div className="p-1.5 pb-0.5 flex-1">
            <h3 className="text-[10px] font-bold text-gray-900 leading-tight truncate">
              {entry.name}
            </h3>
            {(entry as any).description && (
              <p className="text-[9px] text-gray-500 leading-snug mt-0.5 line-clamp-2">{(entry as any).description}</p>
            )}
          </div>
        </>
      )}
      <div className="px-1.5 pb-1.5 pt-0.5">
        <SocialLinks item={entry} variant="sleek" />
      </div>
    </motion.div>
  );
}

export default function PhotoVideo() {
  const [query, setQuery] = useState('');
  const [isDescExpanded, setIsDescExpanded] = useState(false);
  const mc = useManagedCollection<any>('photo_video', PHOTO_VIDEO_ENTRIES, (e, i) => slugify(e.id || e.name || String(i)));

  const filtered = mc.items
    .filter((entry) =>
      query.trim() === '' || entry.name.toLowerCase().includes(query.trim().toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="min-h-screen bg-white">
      <CategoryHero
        placeholder="Search photo/video…"
        query={query}
        setQuery={setQuery}
        hideLocation
      />
      <NewsTicker />

      <section className="bg-gray-50/50 py-8" style={{ fontFamily: "'Poppins', sans-serif" }}>
        <div className="max-w-[1320px] mx-auto px-4">
          <h2 className="text-[18px] sm:text-[20px] md:text-[22px] font-bold text-gray-900 mb-1">
            Indian, Pakistani & South Asian Wedding Photographers in Dallas–Fort Worth
          </h2>

          {(() => {
            const introParagraphs = [
              "Find Indian wedding photographers in Dallas, South Asian wedding photographers in Dallas, Pakistani wedding photographers, and professional wedding photographers in DFW with DallasDesiScoop. Discover photographers and videographers for Indian and Pakistani weddings, engagements, bridal shoots, mehndi, sangeet, receptions, birthdays, baby showers, family portraits, cultural events, corporate events, parties, and special occasions. Explore wedding photography, wedding videography, wedding cinematography, portrait photography, photo booths, drone photography, and professional photo and video services.",
            ];
            const [firstParagraph, ...restParagraphs] = introParagraphs;

            return (
              <>
                {/* Mobile: first paragraph + Read more toggle */}
                <div className="sm:hidden">
                  <p className="text-[12px] text-gray-500 mb-2">
                    {firstParagraph}
                  </p>
                  {restParagraphs.length > 0 && (
                    <>
                      {isDescExpanded && restParagraphs.map((para, i) => (
                        <p key={i} className="text-[12px] text-gray-500 mb-2">
                          {para}
                        </p>
                      ))}
                      <button
                        type="button"
                        onClick={() => setIsDescExpanded((v) => !v)}
                        className="text-[12px] font-semibold mb-4"
                        style={{ color: '#f97316' }}
                      >
                        {isDescExpanded ? 'Read less' : 'Read more'}
                      </button>
                    </>
                  )}
                  {restParagraphs.length === 0 && <div className="mb-4" />}
                </div>

                {/* Desktop / tablet: full text, no truncation */}
                <div className="hidden sm:block">
                  {introParagraphs.map((para, i) => (
                    <p
                      key={i}
                      className={`text-[13px] text-gray-500 ${i === introParagraphs.length - 1 ? 'mb-6' : 'mb-2'}`}
                    >
                      {para}
                    </p>
                  ))}
                </div>
              </>
            );
          })()}

          <AdminAddBar mc={mc} fields={PHOTO_VIDEO_FIELDS} label="Add Photo/Video" />

          {/* Featured by TastebudsByAnubhi */}
          <div className="mb-8">
            <h3 className="text-[14px] sm:text-[16px] font-bold text-green-700 mb-3 flex items-center gap-2">
              Featured by TastebudsByAnubhi
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
              <ShoppingCard store={FEATURED_TASTEBUDS_ENTRY as any} index={0} compact tightFeatured forceFeatured linkDetail detailBase="/photo-video" linkImageDetail />
              <ShoppingCard store={FEATURED_TASTEBUDS_ENTRY_FLASHBRUSH as any} index={1} compact tightFeatured forceFeatured linkDetail detailBase="/photo-video" linkImageDetail />
            </div>
          </div>

          {/* More Photo & Video */}
          {filtered.length > 0 ? (
            <div>
              <h3 className="text-[14px] sm:text-[16px] font-bold text-gray-700 mb-3">
                More Photo & Video
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
                {filtered.map((entry, i) => (
                  <AdminItem key={(entry as any)._mcId} mc={mc} item={entry as any} fields={PHOTO_VIDEO_FIELDS} title="Photo/Video">
                    <PhotoVideoCard entry={entry as any} index={i} linkDetail />
                  </AdminItem>
                ))}
              </div>
            </div>
          ) : (
            <div className="bg-white border border-dashed border-gray-200 rounded-2xl p-8 text-center text-[13px] text-gray-500">
              No photo/video entries match your search.
            </div>
          )}

          <p className="text-[13px] text-gray-500 mt-8">
            Looking for an Indian wedding photographer near you, South Asian wedding photographer in Dallas, Pakistani wedding photographer in DFW, Indian videographer, or professional wedding photographer? Explore photographers and videographers serving Dallas, Frisco, Plano, Irving, McKinney, Allen, The Colony, Prosper, Lewisville, Carrollton, Coppell, Richardson, Flower Mound, Little Elm, and surrounding North Texas communities. DallasDesiScoop helps you discover and connect with local photo and video professionals for weddings, celebrations, cultural events, and special occasions across DFW.
          </p>
        </div>
      </section>
    </div>
  );
}
